import { Section } from "../FileStructure";
import { SectionState } from "./NavigationList";
import ListItem from "./ListItem";
import CollapsibleItem from "./CollapsibleItem";


export const renderSections = (sections: Section[], level = 0, sectionState: SectionState, toggleSection: (section: string) => void) => {
    return sections.map((section, index) => {
        const hasSubsections = section.subsections.length > 0;
    
        if (hasSubsections) {
          return (
            <CollapsibleItem
              key={`${level}-${index}`}
              section={section}
              sectionState={sectionState}
              toggleSection={toggleSection}
            />
          );
        }
    // About This Report
        return (
          <ListItem
            key={`${level}-${index}`}
            section={section}
            sectionState={sectionState}
            toggleSection={toggleSection}
            hasSubsections={false}
          />
        );
      });
  };
  

  